import {Component} from '@angular/core';
import {ActivatedRoute} from "@angular/router";
import {TranslateService} from "app/translate/translate.service";
import {FilterFormService} from "app/views/filter_form/filter_form.service";
import {ChartParams} from "app/views/chart/chart.component";
import {EventsService} from "app/lib/EventsService";
import {BaseComponent} from "app/views/base.component";
import { ChartModel } from "app/models/chart.model";
import { BillingService2 } from "../billing.service";
import { FilterParams } from "../../models/filter_form.model";

@Component({
	selector: 'app-money',
	template: `
		<cache-date></cache-date>

		<period></period>

		<filterForm [addFilterParams]="filter.addFilterParams"></filterForm>

		<hr/>

		<chart [data]="accumFirst.data" [options]="accumFirst.options" [sextant]="'accum'"></chart>

		<hr/>

		<chart [data]="moneyChart.data" [options]="moneyChart.options" (onFilterChange)="updateData($event, 'money')" [sextant]="'money'"></chart>

		<hr/>

		<chart [data]="amountPeriodChart.data" [options]="amountPeriodChart.options" (onFilterChange)="updateData($event, 'period')" [sextant]="'amount-period'"></chart>

		<div class="alert alert-info" role="alert">
			<ul>
				<li>
					Вечный тариф, который сделан как оплата на 100 лет, тут учитывается как на 120 месяц (10 лет)
				</li>
				
				<li>
					Вечный тариф, оплаченый токенами - исключён
				</li>
			</ul>
		</div>

		<hr/>

		<chart [data]="accumSecondPaidChart.data" [options]="accumSecondPaidChart.options" [sextant]="'accum-second-manual'"></chart>

		<hr/>

		<chart [data]="secondManualChart.data" [options]="secondManualChart.options"></chart>
	`,
	providers: [ChartModel]
})
export class MoneyComponent extends BaseComponent {
	addFilterParams = {
		userType      : 'user',
		isBilling     : true,
		dateFilters   : ['datePaid', 'dateCreated', 'dateSiteCreated'],
		promocodeMark : ''
	};
	
	
	accumFirst           = new ChartParams({
		filter: {
			datePeriodList: []
		}
	});
	
	moneyChart           = new ChartParams({
		filter: {
			datePeriodList: []
		}
	});
	
	amountPeriodChart    = new ChartParams({
		filter: {
			datePeriodList: []
		}
	});
	
	accumSecondPaidChart = new ChartParams({
		filter: {
			datePeriodList: []
		}
	});

	secondManualChart = new ChartParams({
		filter: {
			datePeriodList: []
		}
	});
	
	constructor(
		public activatedRoute: ActivatedRoute,
		public translate: TranslateService,
		public filter: FilterFormService,
		public eventsService: EventsService,
		public money: ChartModel,
		public service2: BillingService2,
	) {
		super(eventsService, service2, activatedRoute, filter, translate);
		
		const labels  = {
			moneyCount                       : this.translate.__A('billing._money.moneyCount'),
			firstManualMoneyCount            : this.translate.__A('billing._money.firstManualMoneyCount'),
			rebuildAndSecondManualMoneyCount : this.translate.__A('billing._money.rebuildAndSecondManualMoneyCount'),
			secondManualMoney                : this.translate.__A('billing._money.secondManualMoney'),
			recurrentMoneyCount              : this.translate.__A('billing._money.recurrentMoneyCount'),
			
			avgCheck                         : this.translate.__A('billing._money.avg check'),
			avgPaidPeriod                    : this.translate.__A('billing._money.avg paid period'),
			
			current                          : this.translate.__A('billing._money.current'),
			yesterday                        : this.translate.__A('billing._money.yesterday'),
			accumPaidInCurrentDayOfWeek      : this.translate.__A('billing._money.accumPaidInCurrentDayOfWeek'),
			avgFirstManual                   : this.translate.__A('billing._money.avg first manual'),
			avgFirstManualPeriod             : this.translate.__A('billing._money.avg first manual period')
		};
		
		
		this.accumFirst.setOptions({
			title: this.translate.__A('billing._money.cumulative payment graph'),
			names: labels,
			colors: {
				yesterday : 'rgb(255, 127, 14)',
				current   : 'rgb(140, 86, 75)',
				accumPaidInCurrentDayOfWeek: '#0AC2FF'
			},
			keysMap: [
				'yesterday',
				'accumPaidInCurrentDayOfWeek',
				'current'
			],
			axis: {
				x : {
					type: 'indexed'
				}
			}
		});
		
		
		this.moneyChart.setOptions({
			title: this.translate.__A('common.Money'),
			showLabels: [
				'moneyCount', 'firstManualMoneyCount', 'rebuildAndSecondManualMoneyCount'
			],
			colors : {
				'moneyCount'                       : '#2ca02c',
				'firstManualMoneyCount'            : '#8c564b',
				'rebuildAndSecondManualMoneyCount' : '#bcbd22'
			},
			names  : labels,
			axis     : {
				x : {
					tick : {
						fit    : false,
						format : '%d-%m-%Y'
					}
				}
			}
		});
		
		this.amountPeriodChart.setOptions({
			title: this.translate.__A('billing._money.check and period'),
			showLabels : [
				'avgPaidPeriod', 'avgCheck', 'avgFirstManual', 'avgFirstManualPeriod'
			],
			axes     : {
				avgPaidPeriod        : 'y',
				avgCheck             : 'y2',
				avgFirstManual       : 'y2',
				avgFirstManualPeriod : 'y'
			},
			names    : labels,
			colors   : {
				avgCheck       : '#9467bd',
				avgPaidPeriod  : '#e377c2'
			},
			axis: {
				y: {
					min   : 1,
					ticks : 5,
					label: {
						text     : labels.avgPaidPeriod,
						position : 'outer-middle'
					}
				},
				y2: {
					show: true,
					label: {
						text     : labels.avgCheck,
						position : 'outer-middle'
					}
				}
			}
		});
		
		this.accumSecondPaidChart.setOptions({
			title: this.translate.__A('billing._money.cumulative payment graph repeated manul'),
			names: labels,
			colors: {
				yesterday : 'rgb(255, 127, 14)',
				current   : 'rgb(140, 86, 75)',
				accumPaidInCurrentDayOfWeek: '#0AC2FF'
			},
			keysMap: [
				'yesterday',
				'accumPaidInCurrentDayOfWeek',
				'current'
			],
			axis: {
				x : {
					type: 'indexed'
				}
			}
		});

		this.secondManualChart.setOptions({
			title: 'Вторичные ручные платежи',
			names: {
				expiredCount: 'Просроченный платный тариф',
				activeCount: 'Активный платный тариф',
				paidWithoutFirstManualCount: 'Оплата без предыдущей оплаты',
			}
		});
	}
	
	
	async getData() {
		const me = this;
		
		const fp = me.filter.getFilterParams();

		me.accumFirst.showLoader();
		const { charts: accumFirstData } = await me.service2.money.chart(
			me.filter.getCopyFilterParams({
				paidType    : 'firstManual',
				chartFormat : 'c3angular'
			}),
			'accum/chart'
		).toPromise();
		me.accumFirst.data = accumFirstData;
		me.accumFirst.hideLoader();

		await me.getMoneyTotal(fp);
		
		await me.getAmountPeriod(fp);
		
		me.accumSecondPaidChart.showLoader();
		const { charts: accumSecondPaidChartData } = await me.service2.money.chart(
			me.filter.getCopyFilterParams({
				paidType: 'secondManual'
			}),
			'accum/chart'
		).toPromise();
		me.accumSecondPaidChart.data = accumSecondPaidChartData;
		me.accumSecondPaidChart.hideLoader();

		me.secondManualChart.showLoader();
		const { charts: secondManualChartData } = await me.service2.money.chart(
			fp,
			'second_manual'
		).toPromise();
		me.secondManualChart.data = secondManualChartData;         
		me.secondManualChart.hideLoader();
	}

	async getAmountPeriod(fp: FilterParams) {
		const me = this;
		
		me.amountPeriodChart.showLoader();
		const { charts: amountPeriodChartData } = await me.service2.money.chart(
			fp,
			'moneyTotal2Data'
		).toPromise();
		me.amountPeriodChart.data = amountPeriodChartData;
		me.amountPeriodChart.hideLoader();
	}
	
	async getMoneyTotal(fp: FilterParams) {
		const me = this;
		
		me.moneyChart.showLoader();
		const { charts: moneyChartData } = await me.service2.money.chart(
			fp,
			'moneyTotalData'
		).toPromise();
		me.moneyChart.data = moneyChartData;
		me.moneyChart.hideLoader();
	}
	
	
	async updateData(filter, chartServiceName) {
		const fp = this.filter.getCopyFilterParams(filter);
		
		switch(chartServiceName) {
			case 'money':
				await this.getMoneyTotal(fp);
				
				break;
			case 'period':
				await this.getAmountPeriod(fp);
				
				break;
			default:
				// nope
		}
	}
}
